import React from 'react';
import { connect } from "react-redux";
import { fetchDocumentsByCompanyArea,downloadDocumentFileByCompanyArea } from "./actions";
import Button from 'components/CustomButtons/CustomButton.jsx';
import LoadingIcon from "components/utils/LoadingIcon";

class DocumentList extends React.Component {

    constructor(props){
        super(props);

        this.handleDownloadFile.bind(this);
    }
    componentDidMount() {
        this.props.fetchDocumentsByCompanyArea();
    }

    handleDownloadFile(filename) {
        this.props.downloadDocumentFileByCompanyArea(filename);
    }

    render(){ 
        return (<LoadingIcon success={<table className="table table-striped"><tbody>{this.props.documents.length > 0 ? this.props.documents.map((item, key) => {
            return (<tr key={key}><td><span>{item.filename}</span></td><td><Button fill bsStyle="primary" onClick={() => this.handleDownloadFile(item.filename)}><span className="fa fa-download"></span> Ladda ned</Button></td></tr>)
        }) : null}</tbody></table>} text="Laddar dokument.." isLoading={this.props.isLoadingDocuments} loadingFailed={this.props.loadingDocumentsFailed} />);
    }
}



function mapStateToProps(state) {
    return {
      documents: state.krishantering.documents,
      documentsTimestamp: state.krishantering.documentsTimestamp,
      isLoadingDocuments: state.krishantering.isLoadingDocuments,
      loadingDocumentsFailed: state.krishantering.loadingDocumentsFailed
    };
  }
  
  export default connect(mapStateToProps, { fetchDocumentsByCompanyArea, downloadDocumentFileByCompanyArea })(DocumentList);